import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Paper, Typography } from '@mui/material';

import { epoch } from '../../../shared';
import { isSameIBAN, maskIBAN } from '../../../utils/iban';

import {
  StyledPayoutDetailsContainer,
  StyledVerticalContent,
} from './ClaimDetailsAdditionalPayments.styled';

const ClaimDetailsAdditionalPayments = ({ otherPayouts, customerIBAN }) => {
  return (
    <Paper>
      <StyledVerticalContent>
        <Typography variant="h3">
          <FormattedMessage id="claim.status.details.other.payouts" />
        </Typography>

        <div>
          {Array.isArray(otherPayouts) &&
            otherPayouts.map((payout) => {
              return (
                <StyledPayoutDetailsContainer key={payout?.key}>
                  <Typography variant="p" color="product_blue">
                    <FormattedMessage
                      id="claim.status.details.invoice.from"
                      values={{ createdAt: epoch(payout?.createdAt) }}
                    />
                  </Typography>

                  <Typography variant="p">
                    <FormattedMessage
                      id={
                        payout?.confirmedAt
                          ? 'claim_details.additional_payments.payout_confirmed'
                          : 'claim_details.additional_payments.payout_not_confirmed_yet'
                      }
                      values={{
                        sameIban: isSameIBAN(customerIBAN, payout?.recipientIban),
                        payoutAmount: (payout?.amountCents ?? 0) / 100,
                        confirmedAt: epoch(payout?.confirmedAt),
                        recepientName: payout?.recipientName,
                        recepientIban: maskIBAN(payout?.recipientIban),
                      }}
                    />
                  </Typography>
                </StyledPayoutDetailsContainer>
              );
            })}
        </div>
      </StyledVerticalContent>
    </Paper>
  );
};

export default ClaimDetailsAdditionalPayments;
